Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

exports.SessionStatus = void 0;
(function (SessionStatus) {
    SessionStatus["Idle"] = "IDLE";
    SessionStatus["Started"] = "STARTED";
    SessionStatus["TalkingWithAgent"] = "TALKING_WITH_AGENT";
})(exports.SessionStatus || (exports.SessionStatus = {}));
exports.ChatSourceName = void 0;
(function (ChatSourceName) {
    ChatSourceName["AUTOMATION_REPORT_ISSUE"] = "automations_report_issue_button";
    ChatSourceName["AUTOMATION_CENTER"] = "automation-center";
    ChatSourceName["DIRECT_TRIGGERING_IN_PLATFORM"] = "direct_triggering";
    ChatSourceName["KNOWLEDGE_BASE_FLOATING_CHAT"] = "knowledge-base-floating-chat";
    ChatSourceName["HELP_CENTER_IN_APP"] = "HC_in_app";
    ChatSourceName["HELP_CENTER_V3"] = "help_center_v3";
    ChatSourceName["CONTACT_SALES_HOMEPAGE"] = "contact-sales-homepage";
    ChatSourceName["CONTACT_SALES_PLATFORM"] = "contact-sales-platform";
    ChatSourceName["PLATFORM_CONTACT_SUPPORT"] = "platform-contact-support";
    ChatSourceName["BILLING_CREDIT_CARD_ERROR"] = "billing-credit-card-error";
    ChatSourceName["CSAT_RESPONSE"] = "csat-response";
    ChatSourceName["PRICING_PAGE"] = "pricing_page_dialog";
    ChatSourceName["LOGIN_PAGE"] = "login_page";
    ChatSourceName["SIDEKICK_CHAT"] = "sidekick_chat";
    ChatSourceName["JAX_CALL_WIDGET"] = "jax_call_widget";
})(exports.ChatSourceName || (exports.ChatSourceName = {}));
